// Module
var code = "<div ng-repeat=\"contactinfo in vm.contactInfos\" class=\"ca-searchlist-detail\">\n    <span tooltip-append-to-body=\"true\" uib-tooltip=\"{{contactinfo.value}}\" class=\"ca-searchlist-detail-label\">{{contactinfo.contactInfoType.typeName}} </span>\n    <span >{{contactinfo.value}}</span>\n</div>";
// Exports
module.exports = code;